function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.52032 0.358917C5.58291 0.146125 5.7782 0 6 0H10C10.1607 0 10.3116 0.0772606 10.4056 0.207645C10.4996 0.338029 10.5252 0.50564 10.4743 0.658114L8.69372 6H12.5C12.691 6 12.8653 6.10878 12.9492 6.28032C13.0331 6.45187 13.0119 6.65623 12.8947 6.80697L5.89468 15.807C5.74649 15.9975 5.48334 16.055 5.26922 15.9436C5.05509 15.8321 4.95113 15.5837 5.02211 15.353L6.82302 9.5H3.5C3.34243 9.5 3.19407 9.42572 3.09967 9.29955C3.00526 9.17338 2.97586 9.01009 3.02032 8.85892L5.52032 0.358917ZM6.37412 1L4.16824 8.5H7.5C7.65868 8.5 7.80793 8.57531 7.9022 8.70295C7.99647 8.83058 8.02456 8.99539 7.97789 9.14704L6.78016 13.0397L11.4777 7H8C7.83928 7 7.68836 6.92274 7.59438 6.79236C7.50041 6.66197 7.47484 6.49436 7.52566 6.34189L9.30629 1H6.37412Z",
  fill: "#969BFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21 4C21.2761 4 21.5 4.22386 21.5 4.5V7.5H24.5C24.7761 7.5 25 7.72386 25 8C25 8.27614 24.7761 8.5 24.5 8.5H21.5V11.5C21.5 11.7761 21.2761 12 21 12C20.7239 12 20.5 11.7761 20.5 11.5V8.5H17.5C17.2239 8.5 17 8.27614 17 8C17 7.72386 17.2239 7.5 17.5 7.5H20.5V4.5C20.5 4.22386 20.7239 4 21 4Z",
  fill: "#969BFF"
});

var SvgSparkPlus = function SvgSparkPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 16,
    viewBox: "0 0 29 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSparkPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spark-plus.65c57f58.svg";
export { ForwardRef as ReactComponent };